/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, plural: NonNullable<unknown> }} Resumes_CountInputs */

const en_resumes_count = /** @type {(inputs: Resumes_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resume${i?.plural}`)
};

const de_resumes_count = /** @type {(inputs: Resumes_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Lebenslauf${i?.plural}`)
};

const fr_resumes_count = /** @type {(inputs: Resumes_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} CV`)
};

const es_resumes_count = /** @type {(inputs: Resumes_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} currículum${i?.plural}`)
};

const it_resumes_count = /** @type {(inputs: Resumes_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} curriculum${i?.plural}`)
};

const nl_resumes_count = /** @type {(inputs: Resumes_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} CV${i?.plural}`)
};

const pl_resumes_count = /** @type {(inputs: Resumes_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} CV${i?.plural}`)
};

const fi_resumes_count = /** @type {(inputs: Resumes_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ansioluettelo${i?.plural}`)
};

const da_resumes_count = /** @type {(inputs: Resumes_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} CV${i?.plural}`)
};

const sv_resumes_count = /** @type {(inputs: Resumes_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} CV${i?.plural}`)
};

/**
* | output |
* | --- |
* | "{count} resume{plural}" |
*
* @param {Resumes_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_count = /** @type {((inputs: Resumes_CountInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_CountInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_count(inputs)
	if (locale === "fr") return fr_resumes_count(inputs)
	if (locale === "es") return es_resumes_count(inputs)
	if (locale === "it") return it_resumes_count(inputs)
	if (locale === "nl") return nl_resumes_count(inputs)
	if (locale === "pl") return pl_resumes_count(inputs)
	if (locale === "fi") return fi_resumes_count(inputs)
	if (locale === "da") return da_resumes_count(inputs)
	if (locale === "sv") return sv_resumes_count(inputs)
	return en_resumes_count(inputs)
});